import Axios from 'axios'
import config from '../config'

var base = `${config.wordpressUrl}${config.apiLocation}`
var requestConfig = config.wordpressAuth ? { auth: config.wordpressAuth } : {}

export default {
  addToCart (idToken, orderlines) {
    return Axios.post(`${base}/add-to-cart`, {
      idToken,
      orderlines
    }, requestConfig)
  },
  openCart (idToken) {
    var url = `${base}/open-cart?idToken=${idToken}`
    var win = window.open(url, '_blank')
    win.focus()
  }
}
